export const AWS_BASE_URL = process.env.REACT_APP_AWS_BASE_URL;
export const AWS_BUCKET = process.env.REACT_APP_AWS_BUCKET;
